jQuery(document).ready(function ($) {
	const base = 'gc-slider';

	$(`.${base}__slider-inside`).slick({
		arrows: false
	});

	$(`.${base}__previous`).click(function(e) {
		e.preventDefault();

		$(`.${base}__slider-inside`).slick('slickPrev');
	});

	$(`.${base}__next`).click(function(e) {
		e.preventDefault();

		$(`.${base}__slider-inside`).slick('slickNext');
	});

});